module.exports = __webpack_public_path__ + "static/media/激光切割机械爪.a4152723.png";